import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取广告banenr
 * @param data
 */
export function getAdvertisements(codes) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Message/Activity/Activities`,
    method: 'get',
    params: {
      codes: codes
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 获取热门课程
 * @param data
 */
export function getRecommendSetList(size) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/Api/RecommendSetList`,
    method: 'get',
    params: {
      size: size
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 获取锦囊
 * @param pageSize
 */
export function getSilkBagList(pageSize) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/Data/Page`,
    method: 'get',
    params: {
      orderBy: 'desc',
      pageSize: pageSize
    }

  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 获取锦囊
 * @param tag 1每日头条 2电视强档
 * @param limit 限制返回的数据个数
 */
export function getDianJinItems(tag, limit) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/DianJin/Api/GetDianJinItems
`,
    method: 'get',
    params: {
      tag: tag,
      limit: limit
    }

  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}
